/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type InvoiceList_invoiceSettings$ref: FragmentReference;
declare export opaque type InvoiceList_invoiceSettings$fragmentType: InvoiceList_invoiceSettings$ref;
export type InvoiceList_invoiceSettings = {|
  +wiringInstructions: ?string,
  +contactPerson: string,
  +contactPhoneNumber: string,
  +contactEmail: string,
  +$refType: InvoiceList_invoiceSettings$ref,
|};
export type InvoiceList_invoiceSettings$data = InvoiceList_invoiceSettings;
export type InvoiceList_invoiceSettings$key = {
  +$data?: InvoiceList_invoiceSettings$data,
  +$fragmentRefs: InvoiceList_invoiceSettings$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "InvoiceList_invoiceSettings",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "wiringInstructions",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "contactPerson",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "contactPhoneNumber",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "contactEmail",
      "storageKey": null
    }
  ],
  "type": "InvoiceSettings"
};
// prettier-ignore
(node/*: any*/).hash = '3433772837e8e8afc68d46f1122828a7';

module.exports = node;
